import { A } from "@solidjs/router";
import { Component, Show } from "solid-js";
import { RawHtml } from "./raw-html";
import { Img } from "./universal/image";
import { SearchSettings } from "./search-artworks";
import { ContestWinner } from "../Types";
import { P } from "./p";
import { slug } from "../library/common";

type SearchHandlers = {
    togglePeoplesChoiceVote: (id: string) => Promise<void>;
};
type Props = {
    settings?: SearchSettings;
    handlers?: SearchHandlers;
    itemWidth: number;
    item: ContestWinner;    
}
export const ArtworkGridItem : Component<Props> = ({ item, settings, itemWidth: width }) => {
    return (
        <div class="grid-item" style={{ "display": "inline-block", "vertical-align": "top", "text-align": "left", width: `${width}px`, "max-width": `${width}px` }}>
            <div style={{ "position": "relative", "background-color": item.PrimaryImage.DominantColourHexCode || "#333" }}>
                <div>
                    <A href={`/artwork/${slug(item.Title)}/${slug(item.Artist)}/${item.Id}`}>
                        <Img 
                            src={item.PrimaryImage.URL}
                            naturalWidth={item.PrimaryImage.Width} naturalHeight={item.PrimaryImage.Height} maxWidth={width}
                            style={{ width: `${width}px` }}
                        />
                    </A>
                </div>
            </div>
            <div class="didactic">
                <Show when={settings?.ShowArtist}>
                    <h4>
                        <A href={`/artist/${slug(item.Artist)}/${item.ContestEntrantId}`}>{item.Artist}</A>
                    </h4>
                </Show>
                <h2>
                    <A href={`/artwork/${slug(item.Title)}/${slug(item.Artist)}/${item.Id}`}>
                        <RawHtml value={item.Title} />
                    </A>
                </h2>
                <P when={item.Year}>{item.Year}</P>
                <P when={item.Medium}>{item.Medium}</P>
                <RawHtml value={item.Measurements} />
            </div>
        </div>
    )
}